import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { pointsRequestQueries } from '@/services/pointsRequest/pointsRequest.queries';
import { useSearch } from '@tanstack/react-router';

export const usePointsRequest = () => {
  const { sort } = useSearch({
    from: '/(app)/points-management/points-request/',
  });
  const { data, isFetched } = useQuery({
    ...pointsRequestQueries.list(),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { pointsRequestData: data?.data || [], isFetched };
};
